/**
 * Calculates a score for an attribute in personalisation values which
 * is not the primary attribute of that score list
 * Returns a list of attribute values with their aggregated scores
 */
export const calculateAttributeScore = (scores, attribute) => {
  const attributeScoreMap = (scores ?? [])
    .filter((data) => data[attribute])
    .reduce((map, data) => {
      const attributeValue = data[attribute]
      map.set(attributeValue, (map.get(attributeValue) ?? 0) + data.score)
      return map
    }, new Map())

  return [...attributeScoreMap.entries()]
    .map((/** @type {[string, number]} */ [attributeValue, score]) => ({
      [attribute]: attributeValue,
      score
    }))
    .sort((a, b) => b.score - a.score)
}

/**
 * Like calculateAttributeScore but for attributes that are arrays,
 * will grant the score to each value in the array
 */
export const calculateAttributeScoreFlattened = (scores, attribute) =>
  calculateAttributeScore(
    scores?.flatMap(
      (entry) =>
        entry[attribute]?.map((value) => ({ [attribute]: value, score: entry.score })) ?? []
    ),
    attribute
  )

export const getAttributeScoreWeightedAverage = (scores, attribute) => {
  if (!scores?.length) return null

  const weightedSum = scores.reduce(
    (sum, { [attribute]: attrValue, score }) => sum + attrValue * score,
    0
  )
  const totalScore = scores.reduce((sum, { score }) => sum + score, 0)

  return weightedSum / totalScore
}
